module.exports = __webpack_public_path__ + "img/des-2.83bd6b40.jpg";